import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import WhiteLabelLogo from 'components.v2/WhiteLabelLogo/WhiteLabelLogo'

import {
  InfoSection,
  Tags,
  TagsSeparator,
  VendorHeaderContainer,
  VenueName,
} from './styled'
import { MAX_TAGS_COUNT } from 'pages/vendor/const'
import { TagsContainer } from '../VendorHeader/styled'

class VendorHeader extends React.PureComponent {
  render() {
    const { name, tags } = this.props
    const tagsJsx = (tags || [])
      .slice(0, MAX_TAGS_COUNT)
      .reduce(
        (acc, tag) => [
          ...acc,
          <Fragment key={shortid.generate()}>{tag.name}</Fragment>,
          <TagsSeparator key={shortid.generate()}>&bull;</TagsSeparator>,
        ],
        [],
      )
      .filter((x, i, arr) => i !== arr.length - 1)

    return (
      <VendorHeaderContainer>
        <WhiteLabelLogo />
        <InfoSection>
          <VenueName>{name}</VenueName>
          <TagsContainer>{tagsJsx && <Tags>{tagsJsx}</Tags>}</TagsContainer>
        </InfoSection>
      </VendorHeaderContainer>
    )
  }
}

VendorHeader.propTypes = {
  history: PropTypes.object,
  name: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ),
}

VendorHeader.defaultProps = {
  tags: [],
}

export default VendorHeader
